import { StopConnection } from '@/new-transport/_models/transport-timetable.model';

export const createStopConnection = (
	id: number,
	transportStopFrom: number,
	transportStopTo: number,
	kilometers: number,
	minutes: number,
): StopConnection => {
	return {
		id,
		transportStopFrom,
		transportStopTo,
		kilometers,
		minutes,
	};
};
